/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ForeverInputs */

const cs_enum_forever = /** @type {(inputs: Enum_ForeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez omezení`)
};

const en_enum_forever = /** @type {(inputs: Enum_ForeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forever`)
};

/**
* | output |
* | --- |
* | "Forever" |
*
* @param {Enum_ForeverInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_forever = /** @type {((inputs?: Enum_ForeverInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ForeverInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_forever(inputs)
	return cs_enum_forever(inputs)
});